









































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const mineModule = namespace("mine");

@Component
export default class AccountShop extends Vue {
  @mineModule.State("userMsg") userMsg!: any;
  uMsg: any = this.$global.uBusinessEntity;
  uName: string = this.$global.uName;
  uPhone: string = this.$global.uPhone;
  upName: string = this.$global.parentName
    ? decodeURIComponent(this.$global.parentName)
    : "";
  catoryItemName: string = "";
  compare = (property: any) => {
    return function(a: any, b: any) {
      var value1 = a[property];
      var value2 = b[property];
      return value1 - value2;
    };
  };
  mounted() {
    // console.log(this.$global.uBusinessEntity);
    if (this.uMsg && this.uMsg.catoryList) {
      let arr: any = [];
      this.uMsg.catoryList.sort(this.compare("level"));
      console.log(this.uMsg.catoryList);
      this.uMsg.catoryList.map((item: any) => {
        arr.push(item.catoryItemName);
      });
      this.catoryItemName = arr.join(",");
      console.log(this.catoryItemName);
    }
    // this.getMsg()
  }
  // getMsg(){ // 获取用户信息
  //   this.$store.dispatch('mine/getUserMsg', {
  //    accountId: this.$global.uId
  //  })
  // }
}
